export enum ActivityLogActionTypes {
    CREATED = 'CREATED',
    MODIFIED = 'MODIFIED',
    ACCEPTED = 'ACCEPTED',
    SUBMITTED = 'SUBMITTED',
    UNSUBMITTED = 'UNSUBMITTED',
    REVIEWED = 'REVIEWED',
    APPROVED = 'APPROVED',
    CANCELED = 'CANCELED',
    REJECTED = 'REJECTED',
    SCHEDULED_DEPLOYMENT = 'SCHEDULED_DEPLOYMENT',
    DEPLOYED = 'DEPLOYED'
}